import angular from 'angular';

import RwTrendIndicatorComponent from './rw-trend-indicator-component';

export default angular.module('rw-trend-indicator', ['rw-currency']).component('rwTrendIndicator', RwTrendIndicatorComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-trend-indicator/rw-trend-indicator-module.js